import { defineComponent } from '@vue/composition-api';

//

 /**
  * @deprecated Use SdsPassword
  */
var script = defineComponent({
     name: 'SbPasswordErrorMeter',
     props: {
         error: {
             type: Object,
             required: true,
         },
         invalidPasswordMessage: {
             type: String,
             default: '',
         },
     },
     computed: {
         isErrorMeterVisible() {
             return this.hasFullBar || this.hasProgressErrors;
         },
         hasFullBar() {
             return this.error.kind === 'fullBar';
         },
         hasProgressErrors() {
             return this.error.kind === 'progressError';
         },
         hasServerErrors() {
             return this.error.kind === 'serverError';
         },
         progressBarWidth() {
             return `width: ${this.error.progress}%;`;
         }
     },
 });

export default script;
